import React, {
  Component
} from 'react';
import {
  Button,
  Form,
  TextField,
  Dialog
} from '@vitalsource/vstui';
import '../../styles/SignInForm.css';
import studioLoginLogo from "../../img/login-logo.svg";
import styled from "styled-components";
import {LoginMessage} from "../reducers";
import Recaptcha from "./Recaptcha";
import loadRecaptcha from "../utils/loginUtils";

const SignInForm = styled(Form) `
  font-family: "Roboto";
  text-align: center;
`

const SignInFormTextField = styled(TextField)`
  width: 400px;
  display: block;
  margin-bottom: 40px;
  > input {
    height: 100%;
    width: 100%
  }
  input:autofill {
  -webkit-box-shadow: 0 0 0 2rem #e8f0fe inset;
}
`;

interface SigninFormState {
  username: string;
  password: string;
  isValid: boolean;
  forgotPassedDialogOpen: boolean;
}

export interface SigninFormProps {
  login: (username: string, password: string) => void;
  showRecaptcha: boolean;
  message: LoginMessage | null;
  loading: boolean;
  updateRecaptchaId: (id: number) => void;
  isSubmitted: boolean;
}

export default class SigninForm extends Component<SigninFormProps, SigninFormState> {
  constructor(props: SigninFormProps) {
    super(props);

    this.state = {
      username: '',
      password: '',
      isValid: false,
      forgotPassedDialogOpen: false,
    };

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.toggleForgotPasswordDialog = this.toggleForgotPasswordDialog.bind(this);
    this.onRecaptchaReady = this.onRecaptchaReady.bind(this);
  }

  componentDidMount() {
    loadRecaptcha();
  }

  validate(isValid: boolean) {
    this.setState({
      isValid: isValid
    })
  }

  handleSubmit(e: Event) {
    e.preventDefault();

    if (this.state.isValid) {
      if (!this.props.isSubmitted) {
        this.props.login(this.state.username, this.state.password);
      }
      else {
        console.info("Form already submitted");
      }
    }
  }

  handleFieldChange(e: Event) {
    const target = e.target as HTMLInputElement;
    if (target) {
      const id = target.id;
      const value = target.value;

      this.setState({
        [id]: value
      } as any);
    }
  }

  showIfError(message: LoginMessage | null) {
    if ( !message ) {
      return '';
    } else {
      return (<div className="signin-error-message">{message.text}</div>);
    }

  }

  toggleForgotPasswordDialog(state: boolean) {
    this.setState({
      forgotPassedDialogOpen: state
    });
  }

  onRecaptchaReady(id: number) {
    this.props.updateRecaptchaId(id);
  }

  getDialog() {
    return (<Dialog
      closeButtonLabel="Close"
      onRequestClose= { () => this.toggleForgotPasswordDialog(false)}
      open={this.state.forgotPassedDialogOpen}
      primaryActionButton={{
        label: 'Continue',
        onClick: () =>{
          this.toggleForgotPasswordDialog(false);
          window.open(`${process.env.REACT_APP_MANAGE_URL}/forgot_password`, '_blank');
        }
      }}
      rootSelector="#signInForm "
      secondaryActionButton={{
        label: 'Stay on This Page',
        onClick: () => { this.toggleForgotPasswordDialog(false)}
      }}
      size="medium"
      title="After resetting your password:"
    >
      <div>
      1. Close the VitalSource Manage page that appears<br/>
      2. Return to Studio to sign in
      </div>
    </Dialog>)
  }

  render() {
    return (
      <div className="sign-in-form">
        {this.state.forgotPassedDialogOpen ? this.getDialog():""}
        <SignInForm id="signInForm"  className="vstui-form" onSubmit={this.handleSubmit} onValidate={this.validate}>
          <img className="signin-image" src={studioLoginLogo}/>
          {this.showIfError(this.props.message)}
          <SignInFormTextField
            id="username"
            name="username"
            size="large"
            label="Username"
            onChange={this.handleFieldChange}
            required
            type="text"

          />
          <SignInFormTextField
            id="password"
            name="password"
            size="large"
            label="Password"
            onChange={this.handleFieldChange}
            required
            type="password"
          />
          <Recaptcha
            visible={this.props.showRecaptcha}
            onLoad={this.onRecaptchaReady}
          />
          <Button
            fullWidth
            label="Sign In"
            size="large"
            type="submit"
          >
            Sign In
          </Button>
          {this.props.loading ?  <img className="signin-spinner" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />: ""}
          <div className="link-context"><a className="sign-in-form-link" href="#" onClick={ () => this.toggleForgotPasswordDialog(true)}>Forgot your password?</a></div>
          <div className="link-context">Don’t have an account? <a className="sign-in-form-link" target="_blank" href="https://get.vitalsource.com/content-creation">Request a demo.</a></div>
        </SignInForm>
      </div>
    )
  }
}
